import angular from 'angular';
import moment from 'moment';

(function () {
    'use strict';
    angular.module('app.community').factory('Community', CommunityData);

    function CommunityData() {
        Community.prototype = {
            build: build,
        };

        function Community(communityData) {
            if (communityData) {
                this.build(communityData);
            }
        }

        return Community;

        /////////////////////

        function build(communityData) {
            this.eid = communityData.eid;
            this.name = communityData.name;
            this.alias = communityData.alias || null;
            this.creationDate = moment(communityData.creationDate).format('DD/MM/YYYY');
            this.managingStockSoftware = communityData.managingStockSoftware;
            this.usingCga = communityData.usingCga;
            this.mandatoryCGVAcceptance = communityData.mandatoryCGVAcceptance;
            this.documentId = communityData.documentId;
            this.workflowOrderEntryRef = communityData.workflowOrderEntryRef;
            this.managingReferential = communityData.managingReferential;
            this.usingLegalNotice = communityData.usingLegalNotice;
        }
    }
})();
